// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"763ec9cf","826":"3d711136"}[chunkId] + ".chunk.js";
};